import { Modal, PrimaryButton } from "@fluentui/react";
import React, { useEffect, useState, useContext } from "react";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import ModalMain from "../../../../../components/Modal/ModalMain";
import ModalFooter from "../../../../../components/Modal/ModalFooter";
import ModalHeader from "../../../../../components/Modal/ModalHeader";
import { getStudyInformationFromPACS, pullPacsStudyReport, pushImagesToPACS, reportVersionControl, reportVersionControlMSWord } from "../../../../../service/StudyListService";
import studylistContext from "../../../../../context/studylist/StudylistContext";
import studyReportContext from "../../../../../context/studyreport/StudyReportContext";
import themeContext from "../../../../../context/theme/ThemeContext";
import loaderContext from "../../../../../context/loader/LoaderContext";

const PacsInformation = (props) => {
  const [loading, setLoading] = useState(false);
  const { ref, setLoaderRunning, showModal, setShowModal } = useContext(loaderContext);
  const [pacsInformationData, setPacsInformationData] = useState({});
  const [responseMessage, setResponseMessage] = useState("");
  const [actionResponseMessage, setActionResponseMessage] = useState("");
  const [t] = useTranslation();

  let PrimaryButtonList = [
    {
      title: t("button.close"),
      onclick: () => props.setShowPacsInformationModal(false),
    },
  ];

  const getInformationFromPacs = async() =>{
    setLoading(true);
    const response = await getStudyInformationFromPACS(props.studyId);
    console.log("Get information from pacs response :", response)
    if (response.status == 200 && response.data.result == "SUCCESS") {
      if(response.data.data != null && response.data.data != undefined){
        setPacsInformationData(response.data.data);
      }else{
        setResponseMessage(response.data.message);
      }
      
      setLoading(false);
    } else {
      setLoading(false);
    }
    
  }

  const handlePullReportFromPacs = async() =>{
    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await pullPacsStudyReport(props.studyId);
    console.log("Pull report from pacs response :", response)
    if(response.data.result === "SUCCESS"){
      setActionResponseMessage(response.data.message);
    }
    setLoaderRunning(false);
    ref.current.complete();
  }

  const handlePushImagesToPacs = async() =>{
    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await pushImagesToPACS(props.studyId);
    console.log("Pull report from pacs response :", response)
    if(response.data.result === "SUCCESS"){
      setActionResponseMessage(response.data.message);
    }
    setLoaderRunning(false);
    ref.current.complete();
  }

  useEffect(() => {
    getInformationFromPacs();
  }, []);

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal = {true}
        heading={`${t("pacs-information.title")}`}
        handleCancel={() => props.setShowPacsInformationModal(false)}
      />
    ),
    body: <PacsInformationModal pacsInformationData={pacsInformationData} responseMessage={responseMessage} 
      loading={loading} setShowPacsInformationModal = {props.setShowPacsInformationModal} actionResponseMessage={actionResponseMessage}
      handlePullReportFromPacs ={handlePullReportFromPacs} handlePushImagesToPacs={handlePushImagesToPacs} />,
    footer: (
      <ModalFooter
        PrimaryButtonList={[]}
        DefaultButtonList={PrimaryButtonList}
      />
    ),
    width: "785px",
  };

  return (
    <>
      <ModalMain
        updatedModal = {true}
        modalDetails={modalDetails}
        showModal={props.showPacsInformationModal}
      />
    </>
  );
};

export default PacsInformation;

export const PacsInformationModal = (props) => {
  const [t] = useTranslation();
  const { getThemeColor } = useContext(themeContext);

  const tableStyle = {
    width: "100%",
    color: getThemeColor("primary-color"),
    fontWeight: "400",
    fontFamily: "Open Sans",
  };

  const headStyle = {
    padding: "10px",
    textAlign: "center",
    border: "1px solid #878282",
  };

  const bodyRowDataStyle = {
    padding: "10px",
    textAlign: "left",
    border: "1px solid #878282",
  };

  const reasonBodyStyle = {
    padding: "10px",
    textAlign: "left",
    border: "1px solid #878282",
    wordBreak: "break-all",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "10px"
  };

  const contentStyles = {
    root: {
      backgroundColor: "rgb(22, 21, 20, 0.7)",
    },
  };

  const noReason = {
    padding: "10px",
    textAlign: "center",
    color: getThemeColor("primary-color"),
  };

  const customSpinnerStyle = {
    circle: {
      height: "20px",
      width: "20px",
      borderWidth: "3px",
    },
  };

  const thheadStyle = {
    padding: "10px",
    textAlign: "center",
    border: "1px solid #878282",
    borderBottom:'none'
  };

  console.log("pacs information :", props.pacsInformationData)
  const isPushImagesDisabled = props.pacsInformationData.dptkImageCount === props.pacsInformationData.vdcImageCount;

  return (
    <>
      {props.loading ? (
        <Spinner size={SpinnerSize.small} styles={customSpinnerStyle} />
      ) : (
        <div className="upload-study-modal-container">
          <div className="container-content">
            {Object.keys(props.pacsInformationData).length !== 0 ? (
              <table style={tableStyle}>
                <thead>
                  <tr>
                    <React.Fragment>
                      <th style={thheadStyle}>{t("pacs-information.report-status")} <br/> {t("pacs-information.dptk-vdc")}</th>
                      <th style={thheadStyle}>{t("pacs-information.image-count")} <br/> {t("pacs-information.dptk-vdc")}</th>
                      <th style={thheadStyle}>{t("pacs-information.action")}</th> 
                    </React.Fragment>
                  </tr>
                  <tr style={headStyle}></tr>
                  <tr style={headStyle}></tr>
                  <tr style={headStyle}></tr>
                </thead>
                <tbody id="unassign-modal_body">
                    <tr> 
                  
                      <td style={bodyRowDataStyle}>{props.pacsInformationData.dptkReportDoneStatus} / {props.pacsInformationData.vdcReportDoneStatus}</td>
                      <td style={bodyRowDataStyle}>{props.pacsInformationData.dptkImageCount} / {props.pacsInformationData.vdcImageCount}</td>
                      <td style={reasonBodyStyle}>
                        <PrimaryButton
                          text={t("pacs-information.pull-report")}
                          style={{
                            whiteSpace:'nowrap'
                          }}
                          onClick={() => {props.handlePullReportFromPacs() 
                          }}
                      />
                      <PrimaryButton
                          text={t("pacs-information.push-images")}
                          style={{
                            whiteSpace:'nowrap'
                          }}
                          onClick={() => {props.handlePushImagesToPacs() 
                          }}
                          disabled={isPushImagesDisabled}
                      />
                      </td>
                    </tr>
                </tbody>
              </table>
            ) : (
              <p style={noReason}>{props.responseMessage}</p>
            )}
            {props.actionResponseMessage != "" && 
              <p style={noReason}>{props.actionResponseMessage}</p>
            }
          </div>
        </div>
      )}
    </>
  );
};
